import React from "react";

import { AutoComplete } from "antd";
import PropTypes from "prop-types";

import FloatLabel from "./FloatingLabel";
import "./styles.scss";

const Component = ({ placeholder, onChange, ...props }) => (
  <FloatLabel
    className="container--input"
    label={placeholder}
    labelLeft={"label--left"}
    value={props.value}>
    <AutoComplete
      showSearch
      className="select_Auto__custom"
      size="large"
      onSelect={onChange}
      {...props}
    />
  </FloatLabel>
);

Component.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  hidePlaceholder: PropTypes.bool,
};

Component.defaultProps = {
  placeholder: "",
  hidePlaceholder: false,
  onChange: () => {},
};

export default Component;
